import { computed } from 'mobx';

import { OtpIdentifier, OtpSms } from '~api/RampPgApiSdk';
import {
    MOBILE_NUMBER_VERIFIED_REQUEST_ID,
    OTP_CHANGE_MOBILE_NUMBER,
    OTP_SWITCH_TO_EMAIL_VERIFICATION,
    OTP_TYPE_EMAIL,
    OtpType
} from '~constants/Constants';

import { IOtpViewController, OtpViewController } from './OtpViewController';

export class OtpSmsViewController extends OtpViewController {
    private identifier: OtpSms;

    constructor(params: IOtpViewController) {
        super(params);
        // Get phone/mobile number from form store
        this.loadFromUserStore();
    }

    @computed
    public get data() {
        const { mobileNumber } = this.identifier;

        return {
            ...super.data,
            sendToText: mobileNumber,
            changeToTranslationKey: OTP_CHANGE_MOBILE_NUMBER,
            switchToTranslationKey: OTP_SWITCH_TO_EMAIL_VERIFICATION
        };
    }

    @computed
    public get requestBase(): OtpIdentifier {
        return this.identifier;
    }

    public get switchToOtpType(): OtpType {
        return OTP_TYPE_EMAIL;
    }

    public saveRequestIdIntoUserStore(id: string): void {
        this.userFormStore.setFieldValue(MOBILE_NUMBER_VERIFIED_REQUEST_ID, id);
    }

    private loadFromUserStore = () => {
        this.identifier = {
            mobileNumber: this.userFormStore?.values?.mobileNumber ?? ''
        };
    };
}
